import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import './Sidebar.scss'

const Sidebar = () => {
  const menuItemShow = document.getElementsByClassName('menuele')

  const togglemenulabel = () => {
    for (let i = 0; i < menuItemShow.length; i++) {
      menuItemShow[i].classList.toggle('menu-hide')
      menuItemShow[i].classList.toggle('menu-show')
    }
  }

  const sidebar = useSelector((state: { sidebar: boolean }) => state.sidebar)
  useEffect(() => {
    togglemenulabel()
  }, [sidebar])

  const { pathname } = useLocation()

  return (
    <nav className="sidebar-nav">
      <ul className="nav">
        <li className="nav-title">Navigation</li>

        <li className="nav-item">
          <Link to="/dashboard" className={pathname === '/dashboard' ? 'p-0 nav-link active' : 'p-0 nav-link'}>
            <i className="icon icon-speedometer text-light"></i> Automated Interview
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/systemsettings" className={pathname === '/settings' ? 'p-0 nav-link active' : ' p-0 nav-link'}>
            <i className="icon icon-target"></i> System Settings
          </Link>
        </li>
      </ul>
    </nav>
  )
}

export default Sidebar
